import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, { "on@click": _ctx.close }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
        class: "wrapper"
      }, [
        _createElementVNode("button", {
          class: "close-btn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, "✕"),
        _createElementVNode("img", {
          src: _ctx.getImg(),
          class: "pj",
          alt: "pj"
        }, null, 8, _hoisted_1)
      ])
    ]),
    _: 1
  }, 8, ["on@click"]))
}